// Utility to find object by userData.name in a Three.js hierarchy
export function getObjectByUserDataName(parent, name) {
  let result = null;
  parent.traverse((child) => {
    if (child.userData && child.userData.name === name) {
      result = child;
    }
  });
  return result;
}
